import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from '../components/public/Header';
import Footer from '../components/public/Footer';
import { AnimatePresence, motion } from 'framer-motion';
import { useMobileDetection } from '../hooks/useMobileDetection';
import MobileGatePage from '../pages/public/MobileGatePage';
import { hasPendingOAuthRequest } from '../services/oauthService';

// Shared header/footer chrome for public auth pages; blocks mobile visitors
const PublicLayout: React.FC = () => {
    const location = useLocation();
    const isMobile = useMobileDetection();

    // Gate auth pages on mobile — /product/:id is NOT inside PublicLayout.
    // Exception: someone approving an app connection (#272) — e.g. from the
    // Claude mobile app — must be able to sign in (or register → verify → sign
    // in) on their phone, so the whole auth flow stays open while a consent
    // request is pending in this tab.
    if (isMobile && !hasPendingOAuthRequest()) {
        return <MobileGatePage />;
    }

    return (
        <div className="min-h-screen flex flex-col bg-william-50 relative">
            <Header />
            <main className="flex-grow relative z-10 pt-24">
                <AnimatePresence mode="wait">
                    <motion.div
                        key={location.pathname}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -20 }}
                        transition={{ duration: 0.3 }}
                    >
                        <Outlet />
                    </motion.div>
                </AnimatePresence>
            </main>
            <Footer />
        </div>
    );
};

export default PublicLayout;
